import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {

};
export const mutations = {

};

export const actions = {

  GET_TIPO_ENVIO_AE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("FILL_TIPO_ENVIO", response.data.data.apelaciones.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_ENVIO_AE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("FILL_TIPO_ENVIO", response.data.data.apelaciones.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {

};
